import React, { Component } from "react";

class BoxOffer extends Component {
    render() {
        return (
            <React.Fragment>
                <div className="breadcrumb-area">
                    <div className="architecure-widget box-offer-widget">
                        <BoxCard />
                        <BoxCard />
                        <BoxCard />
                        <BoxCard />
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

export default BoxOffer;

export class BoxCard extends Component{

    constructor(props) {
        super(props);
        this.state = {
            smallFont : {
                fontSize : "0.7rem",
            }
        }
    }

    render(){
        return(
            <div className="box-offer-card">
                <div className="box-image">
                    <img src="images/char.jpg" />
                </div>
                
                <h4>Arata Box - S</h4>
                <div className="box-offer-breadcrumb">
                    <div className="rounds-flex">
                        <h4 className="sec-txt small-txt">$kart tokens</h4>
                        <p className="">$40</p>
                    </div>
                    <div className="rounds-flex">
                        <h4 className="sec-txt small-txt">Character Arata</h4>
                        <p className="">1</p>
                    </div>
                    <div className="rounds-flex">
                        <h4 className="sec-txt small-txt">Racing</h4>
                        <p className="">1</p>
                    </div>
                    <div className="rounds-flex">
                        <h4 className="sec-txt small-txt">Weapons</h4>
                        <p className="">1</p>
                    </div>
                </div>
                <div className="rounds-flex">
                    <h5 className="sec-txt">Price per 1box</h5>
                    <p>0.9BNB</p>
                </div>
                <div>
                    <div className="progress-bar">
                        <div></div>
                    </div>
                </div>
                <div className="rounds-flex">
                    <h5 className="sec-txt">69%</h5>
                    <p className="sub-txt small-txt bold-text" style={this.state.smallFont}>You own 0Arata</p>
                    <h5>130/150 boxes</h5>
                </div>
            </div>

        )
    }
}
